import PrimaryBtn from "../UI/PrimaryBtn";
import styles from "./Events.module.css";
import eventsImg from "../../assets/images/events-bg.png";

const Events = () => {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Events We Conduct</h2>
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <h3 className={styles.title}>play on the best turf</h3>
          <div className={styles.contentContainer}>
            <p className={styles.content}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
              dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
              modi?
            </p>
            <p className={styles.content}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
              dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
              modi?
            </p>
            <p className={styles.content}>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi iure
              dignissimos eveniet sit maiores. Amet nihil vitae, nostrum, nemo
              modi?
            </p>
          </div>
          <PrimaryBtn className={styles.btn}>Know More</PrimaryBtn>
        </div>
        <img className={styles.img} src={eventsImg} alt="Football Ground" />
      </div>
    </section>
  );
};

export default Events;
